export class Container {
    constructor(hook) {
        this.hook = hook;
        this.subscribers = new Set();
    }
    notify() {
        for (const subscriber of this.subscribers) {
            subscriber(this.data);
        }
    }
}
